import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=65863e6a&"
import script from "./FilterTags.controller.js?vue&type=script&lang=js&"
export * from "./FilterTags.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./FilterTags.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "223b0658"
  
)

export default component.exports